import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="navbar"
export default class extends Controller {
  connect (): void {
    window.addEventListener('scroll', this.handleScroll)
  }

  handleScroll = (): void => {
    if (window.pageYOffset > 0) {
      this.element.classList.add('border-b')
    } else {
      this.element.classList.remove('border-b')
    }
  }
}
